import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TerminationRequest } from 'src/app/model/termination-request';
import { TerminationService } from 'src/app/services/termination/termination.service';

@Component({
  selector: 'app-approve-termination-dialog',
  templateUrl: './approve-termination-dialog.component.html',
  styleUrl: './approve-termination-dialog.component.scss'
})
export class ApproveTerminationDialogComponent {
  /** Whether submit button was clicked */
  public isSubmitting: boolean = false;

  /**
   * Default constructor initializes the component with a dialog ref
   * @param dialogRef
   * @param data
   * @param terminationService
   */
  constructor(
    public dialogRef: MatDialogRef<ApproveTerminationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { terminationRecord: TerminationRequest },
    private _terminationService: TerminationService,
  ) {}

  /**
   * Approve the termination and close the dialog
   */
  public approve(): void {
    this.isSubmitting = true;
    this._terminationService.approveTermination(this.data.terminationRecord.id);
    this.dialogRef.close('approved');
  }

  /**
   * Reject the termination and close the dialog
   */
  public reject(): void {
    this.isSubmitting = true;
    this._terminationService.rejectTermination(this.data.terminationRecord.id);
    this.dialogRef.close('rejected');
  }

  /**
   * Cancel and close the dialog without any action
   */
  public cancel(): void {
    this.dialogRef.close(null);
  }
}
